import React, { useState, useEffect, lazy, Suspense, useRef } from "react";
import { useTestContext } from "../context/TestContext";
import { IoIosSearch, MdKeyboardArrowDown } from "../utils/Icons";
import InfiniteScroll from "react-infinite-scroll-component";

// Imports
import UIWrapper from "../components/UIWrapper";
import NavigationTracker from "../components/NavigationTracker";
//import Pagination from "../components/Pagination";
import ProductFilter from "../components/ProductFilter";
import { useLocation, useNavigate } from "react-router-dom";

const ProductCard = lazy(() => import("../components/ProductCard"));
const PackageProductCard = lazy(() =>
  import("../components/PackageProductCard")
);
const SearchCard = lazy(() =>
  import("../components/SearchCard")
);

const brandNames = [
  "All",
  "Pathkind Labs",
  "Redcliffe Labs",
  "Metropolis Healthcare",
  "Agilus Diagnostics",
];

const productType = [
  { title: "All", value: "All" },
  { title: "Tests", value: "Pathology Test" },
  { title: "Packages", value: "package" },
  { title: "X-rays & scans", value: "Radiology" },
];

const Search = () => {
  const {
    selectedSearchData,
    globalSearchData,
    fetchGlobalSearch,
    handleGlobalSearchChange,
    // handleSearchClick,
    globalSearchPagination,
    isDebounceDropdown,
    setIsDebounceDropdown,
    globalSearchQuery,
    setGlobalSearchQuery,
    fetchProductsByBrandAndTypeAndQuery,
    productsByBrandAndTypeAndQuery,
    setProductsByBrandAndTypeAndQuery,
    productsByBrandAndTypeAndQueryPagination,
    productsToBeSearched,
    handleAddProductsToBeSearched,
    handleRemoveProductsToBeSearched,
    setProductsToBeSearched,
    productsBySearchQuery,
    setProductsBySearchQuery,
    fetchProductsBySearchQuery,
    fetchAllSearchedProducts,
    searchedProducts,
    setSearchedProducts,
    setFromProductFilter,
    fetchSearchedProduct,
    productsBySearchQueryPagination,
    fromProductFilter
  } = useTestContext();
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const searchbarRef = useRef();
  const [searchQuery, setSearchQuery] = useState("");
  const [brandName, setBrandName] = useState("");
  const [categoryName, setCategoryName] = useState("");
  const [selectedProductType, setSelectedProductType] =
    useState("");
  const [isBrandName, setIsBrandName] = useState(false);
  const [isCategory, setIsCategory] = useState(false);
  const [loading, setLoading] = useState(false);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const [groupedProducts, setGroupedProducts] = useState({});
  const [filteredGroupedProducts, setFilteredGroupedProducts] = useState([]);
  const [addMoreTest, setAddMoreTest] = useState({ status: false, brand: '' });
  const [paginationProducts, setPaginationProducts] = useState([]);
  const [allProductsSearched, setAllProductsSearched] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();


  const handleFetchProducts = async (productsTobeSearched) => {
    const allProducts = await fetchAllSearchedProducts(productsTobeSearched);
    setAllProductsSearched(allProducts);
    if (productsToBeSearched.length === 0) {
      setProductsToBeSearched(productsTobeSearched);
    }
    setSearchedProducts(productsTobeSearched);
  }



  // Scroll to top with smooth behavior when data changes (or on initial mount)

  useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    if (window.innerWidth < 1024 || /android/.test(userAgent) || /iphone|ipad|ipod/.test(userAgent)) {
      setIsSmallScreen(true);
    }
    const queryParams = new URLSearchParams(location.search);
    const productsParam = queryParams.get('products');
    const parsedProductsParam = productsParam ? decodeURIComponent(productsParam).split('$') : [];
    handleFetchProducts(parsedProductsParam);
    setPaginationProducts([]);
    window.scrollTo({ top: 0, behavior: "smooth" });
    setFromProductFilter(false);
    setGlobalSearchQuery("")
  }, []);

  useEffect(() => {
    setPaginationProducts([]);
  }, [fromProductFilter])


  const handleBrandName = (getBrandName) => {
    setProductsByBrandAndTypeAndQuery([]);
    setBrandName(getBrandName);
    // Filter out the entry where the brand name matches `getBrandName`
    if (getBrandName === "All") {
      setFilteredGroupedProducts(groupedProducts)
      return
    }
    const filteredEntries = Object.entries(groupedProducts).filter(([brandName]) => brandName === getBrandName);
    setFilteredGroupedProducts(Object.fromEntries(filteredEntries))
    setIsBrandName(false);
    setCurrentPage(1);
  };

  // const handlePageChange = async() => {
  //   let paginatedProducts = allProductsSearched;
  //   let totalProducts = allProductsSearched.length;
  //   const limit = 9;
  //   const skip = (currentPage - 1) * limit;

  //   if (productsToBeSearched.length == 1 || addMoreTest.status) {
  //     setTotalPages(Math.ceil(totalProducts / limit));
  //     setPaginationProducts((prev) => [...prev, ...paginatedProducts.slice(skip, skip + limit)]);
  //   } else {
  //     setTotalPages(Math.ceil(totalProducts / limit));
  //   }

  // }


  const handlePageChange = async () => {
    if (!Array.isArray(allProductsSearched)) {
      console.warn("allProductsSearched is not ready yet");
      return;
    }

    const totalProducts = allProductsSearched.length;
    const limit = 9;
    const skip = (currentPage - 1) * limit;

    setTotalPages(Math.ceil(totalProducts / limit));

    if (productsToBeSearched.length === 1 || addMoreTest.status) {
      const paginatedSlice = allProductsSearched.slice(skip, skip + limit);
      setPaginationProducts((prev) => [...prev, ...paginatedSlice]);
    }
  };


  useEffect(() => {
    if (currentPage) {
      handlePageChange();
    }
  }, [currentPage, allProductsSearched])

  const handleProductType = (product) => {
    setSelectedProductType(product.value);
    setCategoryName(product.title)
    setProductsByBrandAndTypeAndQuery([]);
    setIsCategory(false);
    setCurrentPage(1);
  }

  const keyUpTimer = useRef(null);
  const handleKeyUp = () => {
    if (keyUpTimer.current) clearTimeout(keyUpTimer.current);

    keyUpTimer.current = setTimeout(() => {
      setProductsByBrandAndTypeAndQuery([]);
      setCurrentPage(1);
    }, 1000);
  }

  const handleSearchQueryChange = (e) => {
    setProductsBySearchQuery([]);
    setGlobalSearchQuery(e.target.value);
    if (e.target.value.length >= 3) {
      fetchProductsBySearchQuery(e.target.value)
    }
  };

  const handleSearchCancel = () => {
    setProductsByBrandAndTypeAndQuery([]);
    setGlobalSearchQuery("");
  };

  const loadMore = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
    }
  };

  useEffect(() => {
    setLoading(true);

    // If brandName is "all", skip filtering and set all products
    if (brandName === "All" || brandName === "") {
      setFilteredProducts(paginationProducts);
    }

    else {
      // Filter products based on brandName
      const filtered = allProductsSearched.filter(product => {
        // Check if the product's brandName matches the provided brandName (case-insensitive)
        return product.brandName && product.brandName.toLowerCase() === brandName.toLowerCase();
      });
      setFilteredProducts(filtered);
    }

    setLoading(false);

  }, [brandName, allProductsSearched]);

  useEffect(() => {
    setLoading(true);

    // If brandName is "all", skip filtering and set all products
    if (selectedProductType === "" || selectedProductType === "All") {
      setFilteredProducts(paginationProducts);
    }

    else {
      // Filter products based on brandName
      const filtered = allProductsSearched.filter(product => {
        // Check if the product's brandName matches the provided brandName (case-insensitive)
        return product.productType && product.productType.toLowerCase() === selectedProductType.toLowerCase();
      });
      setFilteredProducts(filtered);
    }

    setLoading(false);

  }, [selectedProductType, allProductsSearched]);

  useEffect(() => {

    setFilteredProducts(paginationProducts);
  }, [paginationProducts])


  const handleSearchClick = async () => {
    if (productsToBeSearched.length > 0) {
      setPaginationProducts([]);
      setCurrentPage(1);
      setLoading(true);
      const productsSearched = await fetchAllSearchedProducts(productsToBeSearched);
      setAllProductsSearched(productsSearched);
      setLoading(false);
      setGlobalSearchQuery("");
      setSearchedProducts(productsToBeSearched);
      const queryParam = productsToBeSearched.join('$');
      navigate({
        pathname: location.pathname,
        search: `?products=${encodeURIComponent(queryParam)}`,
      });
    }
  };
  
  useEffect(() => {
    if (Array.isArray(allProductsSearched) && allProductsSearched.length > 0) {
      const grouped = groupProductsByBrand(allProductsSearched);
      setGroupedProducts(grouped);
    }
  }, [allProductsSearched]);

  //   const handleSearchClick = async () => {
  //   if (productsToBeSearched.length > 0) {
  //     // Optional: show loading spinner immediately
  //     setLoading(true);

  //     // Add a delay (e.g. 500ms) before proceeding
  //     setTimeout(async () => {
  //       setPaginationProducts([]);
  //       setCurrentPage(1);

  //       const productsSearched = await fetchAllSearchedProducts(productsToBeSearched);
  //       setAllProductsSearched(productsSearched);
  //       setLoading(false);
  //       setGlobalSearchQuery("");
  //       setSearchedProducts(productsToBeSearched);

  //       const queryParam = productsToBeSearched.join('$');
  //       navigate({
  //         pathname: location.pathname,
  //         search: `?products=${encodeURIComponent(queryParam)}`,
  //       });
  //     }, 500); // Delay in milliseconds (adjust as needed)
  //   }
  // };


  // useEffect(() => {
  //   if (searchedProducts.length > 1) {
  //     const grouped = groupProductsByBrand(allProductsSearched);
  //     setGroupedProducts(grouped);
  //   }
  // }, [allProductsSearched])



  useEffect(() => {
    setFilteredGroupedProducts(groupedProducts);
  }, [groupedProducts])

  // const groupProductsByBrand = (products) => {
  //   const groupedByBrand = {};
  //   // Loop through each product and group by brand
  //   products.forEach(product => {
  //     const brandName = product.brandName; // Assuming each product has a brandName field
  //     // If the brandName doesn't exist in the grouped object, create an empty array
  //     if (!groupedByBrand[brandName]) {
  //       groupedByBrand[brandName] = [];
  //     }
  //     // Push the product into the corresponding brand's array
  //     groupedByBrand[brandName].push(product);
  //   });

  //   return groupedByBrand;
  // };

  const groupProductsByBrand = (products) => {
    if (!Array.isArray(products)) {
      console.warn("groupProductsByBrand called with non-array:", products);
      return {};
    }

    const groupedByBrand = {};
    products.forEach(product => {
      const brandName = product.brandName || "Unknown"; 
      if (!groupedByBrand[brandName]) {
        groupedByBrand[brandName] = [];
      }
      groupedByBrand[brandName].push(product);
    });

    return groupedByBrand;
  };


  const handleGroupedProducts = (brandToRemove) => {
    // Create a copy of groupedProducts and delete the brand from it
    const updatedGroupedProducts = { ...groupedProducts };

    // Completely remove the brand from the object
    delete updatedGroupedProducts[brandToRemove];

    // Update the state or perform necessary actions
    setGroupedProducts(updatedGroupedProducts);
  };

  const handleAddMoreTestsStatus = (brandName) => {
    setAddMoreTest({ status: true, brand: brandName });

    window.scrollTo({
      top: 0,
      behavior: "smooth", // This makes the scroll smooth
    });
  };

  const scrollContainerRef = useRef(null);

  // Add this useEffect to auto-scroll when products are added
  useEffect(() => {
    if (scrollContainerRef.current && productsToBeSearched.length > 0) {
      const scrollContainer = scrollContainerRef.current;
      scrollContainer.scrollTop = scrollContainer.scrollHeight;
    }
  }, [productsToBeSearched]);


  const handleAddMoreTest = async (item) => {
    const productsToAdd = await fetchSearchedProduct(item, true);
    setGroupedProducts((prev) => {
      // Create a shallow copy of the previous state (prev) object
      const updatedGroupedProducts = { ...prev };

      // Loop through each product in productsToAdd
      productsToAdd.forEach(productToAdd => {
        const brandName = productToAdd.brandName;

        // Check if the brand exists in the groupedProducts object
        if (updatedGroupedProducts[brandName] && addMoreTest.brand === brandName) {
          // If the brand exists, check if this product's title already exists for this brand
          const productExists = updatedGroupedProducts[brandName].some(
            existingProduct => existingProduct.productTitle === productToAdd.productTitle
          );
          // Only add the product if it doesn't already exist
          if (!productExists) {
            updatedGroupedProducts[brandName].push(productToAdd);
          }
        }
      });

      // Return the updated object
      return updatedGroupedProducts;
    });
    setAddMoreTest(false);
    setGlobalSearchQuery("")
  }



  return (
    <UIWrapper searchVisible={false}>
      <div className="w-full h-fit flex flex-col justify-start items-center">
        <div className="w-full h-fit px-[3%] py-0 lg:px-[2%] lg:py-[1%]">
          <NavigationTracker endpoint={"Search"} />
        </div>
        <div className="w-full h-fit flex flex-col justify-center items-center mb-[5%] lg:mb-[1%]">
          <span className="font-semibold text-[5vw] lg:text-[1.5vw] text-textPrimaryColor mb-[0.5%]">
            Find What You're Looking For
          </span>
          <p className="font-normal text-[4vw] lg:text-[1vw] text-textSecondaryColor text-center">
            Search from wide range of pathology lab tests and packages,
            Radiology.
          </p>
        </div>
        <div ref={searchbarRef} className="w-[100%] h-[56px] lg:h-10 flex justify-center items-center px-[3%] lg:px-0 relative">
          <div className={`w-full lg:w-[40%] h-[56px] bg-whiteColor flex justify-between items-center ${addMoreTest.status ? 'animate-blink' : ''}  border-2 border-blue-300 rounded-l-[48px] border-r-0  ${addMoreTest.status ? 'animate-caret-blink' : ''} px-[2%] lg:px-[1%]`}>
            <div className=" h-full w-[100%] bg-whiteColor flex justify-between items-center rounded-[48px]  relative">
              <div className="flex w-full items-center ml-[2%] overflow-y-scroll">
                {productsToBeSearched.length == 0 && (<IoIosSearch className="text-xl text-blue-300 mr-[2%]" />)}
                {productsToBeSearched.length > 0 && (
                  <div ref={scrollContainerRef} className={`h-12 gap-y-2 gap-x-2 grid grid-cols-1 ${productsToBeSearched.length == 1 ? 'lg:grid-cols-1' : 'lg:grid-cols-2'} pt-2 mr-2`}>
                    {productsToBeSearched.map((product, index) => (
                      <div key={index} className="w-full px-2 h-[28px] rounded-[28px] bg-[#E0E0E0] flex justify-between items-center mr-2 text-[13px] text-[#57636C]">
                        <div className="w-fit truncate">
                          {product}
                        </div>
                        <img
                          src="/assets/close-icon.svg"
                          alt="close-icon"
                          className="cursor-pointer ml-1 flex-shrink-0"
                          onClick={() => handleRemoveProductsToBeSearched(product)}
                        />
                      </div>
                    ))}
                  </div>
                )}

                <input
                  type="text"
                  value={globalSearchQuery}
                  onChange={handleSearchQueryChange}

                  placeholder="Search from 12,000+ Lab Tests, Packages, X-rays & Scans"
                  className={`w-[100%] lg:w-[100%] h-full rounded-xl font-normal text-[14px] text-textPrimaryColor placeholder:text-[14px] outline-none`}
                />
                {globalSearchQuery?.length > 0 &&
                  productsBySearchQuery?.length > 0 && (
                    <div className="w-full h-[33vh] bg-whiteColor  border rounded-3xl shadow py-[3%] mt-1 absolute left-0 right-0 top-14 z-50 overflow-scroll scrollbar-hide">
                      {productsBySearchQuery?.map((item, index) => (
                        <div
                          className="w-full h-fit flex justify-between items-center border-b px-[2%] py-[1%] cursor-pointer"
                          key={index}
                          onClick={() => addMoreTest.status ? handleAddMoreTest(item) : handleAddProductsToBeSearched(item)}
                        >
                          <span className="font-normal text-[14px] text-textPrimaryColor">
                            {item}
                          </span>
                        </div>
                      ))}
                    </div>
                  )}
              </div>
              {/** {globalSearchQuery?.length > 0 &&
            globalSearchData?.length > 0 &&
            isDebounceDropdown && (
              <div className="w-full h-[40vh] lg:[33vh] bg-whiteColor border rounded-3xl shadow py-[3%] absolute left-0 right-0 top-12 z-50 overflow-scroll scrollbar-hide">
                {globalSearchData?.map((item, index) => (
                  <div
                    className="w-full h-fit flex justify-between items-center border-b px-[3%] lg:px-[2%] py-[1.5%] lg:py-[1%] cursor-pointer"
                    key={index}
                    onClick={() => handleSearchClick(item)}
                  >
                    <span className="font-normal text-[3.5vw] lg:text-[0.8vw] text-textPrimaryColor">
                      {item?.productTitle}
                    </span>
                    <span className="font-normal text-[3.5vw] lg:text-[0.8vw] text-textPrimaryColor">
                      {item?.productType}
                    </span>
                  </div>
                ))}
              </div>
            )} */}
            </div>
          </div>
          <div className={`lg:w-[10%] h-[56px] flex items-center justify-end lg:justify-between border-t-2 border-e-2 border-b-2 border-blue-300 rounded-e-[48px] pr-[0.5%] lg:pr-[0.2%]  space-x-2 cursor-pointer relative`}>

            <div className={`flex justify-center items-center text-[15px] text-white w-[65px] lg:w-[100%] bg-gradient-to-r from-[#1A67D8] to-[#0047AF] h-[48px] rounded-[48px] cursor-pointer`} onClick={handleSearchClick}>
              <img src="/assets/white-search-icon.svg" alt="" />
            </div>

          </div>

        </div>
        <div className="w-full h-[1px] bg-gray-300 my-[10%] lg:my-[2%]"></div>
        {/* <div className="w-full h-fit flex justify-center items-center px-[3%] lg:px-0 mb-[5%] lg:mb-[2%]">
          <div className="w-full lg:w-[25%] h-fit bg-[#E3E3E3] flex justify-between items-center border rounded-full">
            {productType?.map((item, index) => {
              return (
                <button
                  key={index}
                  className={`${
                    item.value === selectedProductType
                      ? "bg-primaryColor text-whiteColor rounded-full"
                      : "bg-[#E3E3E3] text-textSecondaryColor rounded-full"
                  } px-[5%] py-[3%] lg:py-[2.5%] font-normal text-[3.5vw] lg:text-[1vw] whitespace-nowrap`}
                  onClick={(e) => handleProductType(item.value)}
                >
                  {item.title}
                </button>
              );
            })}
          </div>
        </div> */}
        <div className="flex w-full h-fit justify-between items-center px-[3%] lg:px-[10.7%] mb-[24px] text-[14px] lg:text-[18px] font-medium">
          <div className="lg:flex">
            {searchedProducts?.length == 1 && 'Tests '}Results-{searchedProducts?.length == 1 ? (filteredProducts?.filter((product) => product.productType === "Pathology Test"))?.length : Object.keys(groupedProducts)?.length}
            {searchedProducts?.length == 1 && (
              <div className="lg:ml-5">
                Package Results-{(filteredProducts?.filter((product) => product.productType === "package"))?.length}
              </div>
            )}
            {searchedProducts?.length == 1 && (
              <div className="lg:ml-5">
                Scans Results-{(filteredProducts?.filter((product) => product.productType === "Radiology"))?.length}
              </div>
            )}
          </div>
          <div className="flex items-center space-x-2 lg:space-x-4">
            {searchedProducts?.length == 1 && (
              <div className={`w-[103px] lg:w-[170px] h-[40px] text-[#57636C] text-[14px] flex cursor-pointer justify-center items-center ${isCategory ? 'rounded-t-[16px]' : 'rounded-[16px]'} relative bg-[#E0E0E0]`} onClick={() => { setIsBrandName(false); setIsCategory(!isCategory) }}>
                <div className="truncate pl-2">
                  {categoryName ? categoryName : 'Category'}
                </div>
                <img src="/assets/down-arrow-icon.svg" alt="" className="ml-2" />
                {isCategory && (
                  <div className="bg-[#E0E0E0]  text-[#57636C] items-start w-full flex flex-col border rounded-b-2xl  p-[5%] absolute top-10 left-0 lg:top-10 z-50">
                    {productType.map((product, index) => (
                      <button
                        className="font-normal text-[14px] w-full flex justify-start text-textPrimaryColor border-b pt-[10%] lg:pt-0 pb-[10%] lg:pb-[5%]"
                        key={index}
                        onClick={() => handleProductType(product)}
                      >
                        {product.title}
                      </button>
                    ))}
                  </div>
                )}
              </div>
            )}
            <div className={`w-[103px] lg:w-[180px] h-[40px] text-[#57636C] text-[14px] flex cursor-pointer justify-center items-center ${isBrandName ? 'rounded-t-[16px]' : 'rounded-[16px]'} relative bg-[#E0E0E0]`} onClick={() => { setIsCategory(false); setIsBrandName(!isBrandName) }}>
              <div className="truncate pl-2">
                {brandName ? brandName : 'Brand'}
              </div>
              <img src="/assets/down-arrow-icon.svg" alt="" className="ml-2" />
              {isBrandName && (
                <div className="bg-[#E0E0E0]  text-[#57636C] items-start w-full flex flex-col border rounded-b-2xl  p-[5%] absolute top-10 left-0 lg:top-10 z-50">
                  {brandNames.map((item, index) => (
                    <button
                      className="font-normal text-[14px] w-full flex justify-start text-textPrimaryColor border-b pt-[10%] lg:pt-0 pb-[10%] lg:pb-[5%]"
                      key={index}
                      onClick={() => handleBrandName(item)}
                    >
                      {item}
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>

        </div>
        <div id="products" className="w-full h-fit px-[3%] lg:px-[10%]">
          {/* <div className="w-full h-fit lg:px-[1%] mb-[3%] lg:mb-[1%]">
            <span className="font-normal text-[4vw] lg:text-[1vw] text-textPrimaryColor">
              Result -{" "}
              <strong>
                {productsByBrandAndTypeAndQueryPagination?.totalProducts}
              </strong>
            </span>
          </div> */}
          {!loading ? (
            <>
              {selectedProductType === "package" ? (
                <InfiniteScroll
                  dataLength={filteredProducts?.length}
                  next={loadMore}
                  hasMore={currentPage < totalPages}
                  loader={
                    <div className="w-full h-fit flex justify-center mb-5 items-center">
                      <span className="font-normal text-[4vw] lg:text-[1vw] text-textSecondaryColor">
                        Loading more content...
                      </span>
                    </div>
                  }
                  endMessage={
                    <div className="w-full h-fit flex justify-center mb-5 items-center">
                      <span className="font-normal text-[1vw] text-textSecondaryColor">
                        No more products to load.
                      </span>
                    </div>
                  }
                  scrollThreshold={0.95}
                >
                  <div className="w-full h-[75vh] lg:h-fit grid grid-cols-1 lg:grid-cols-2 gap-x-0 gap-y-4 lg:gap-y-6 mx-auto justify-items-center mb-[3%] lg:mb-[1%] overflow-x-hidden overflow-y-hidden scrollbar-hide">
                    {searchedProducts.length === 1 && filteredProducts?.map((item, index) => (
                      <PackageProductCard data={item} key={index} />
                    ))}
                  </div>
                </InfiniteScroll>
              ) : (
                <InfiniteScroll
                  dataLength={filteredProducts?.length}
                  next={loadMore}
                  hasMore={currentPage < totalPages}
                  loader={
                    <div className="w-full h-fit flex justify-center mb-4 items-center">
                      <span className="font-normal text-14 lg:text-[1vw] text-textSecondaryColor">
                        Loading more content...
                      </span>
                    </div>
                  }
                  endMessage={
                    <div className="w-full h-fit flex justify-center mb-4 items-center">
                      <span className="font-normal text-14 lg:text-[1vw] text-textSecondaryColor">
                        No more products to load.
                      </span>
                    </div>
                  }
                  scrollThreshold={0.9}
                >
                  <div className={`w-full h-fit grid grid-cols-1 ${searchedProducts.length == 1 ? 'lg:grid-cols-3' : 'lg:grid-cols-2'}  gap-y-4 lg:gap-y-6 mx-auto justify-items-center mb-[3%] lg:mb-[1%] overflow-x-hidden overflow-y-hidden  `}>
                    {searchedProducts.length === 1 && filteredProducts?.map((item, index) => (
                      <ProductCard key={index} data={item} />
                    ))}

                    {searchedProducts.length > 1 && Object.keys(filteredGroupedProducts).map((brand, index) => (
                      <SearchCard data={filteredGroupedProducts[brand]} brand={brand} handleGroupedProducts={handleGroupedProducts} handleAddMoreTests={handleAddMoreTestsStatus} />

                    ))}
                  </div>
                </InfiniteScroll>
              )}
            </>
          ) : (
            <div className="flex w-full justify-center font-normal text-[4vw] lg:text-[1vw] text-textSecondaryColor">
              Loading content...
            </div>
          )}
          {/* <Pagination
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            totalPages={productsByBrandAndTypeAndQueryPagination?.totalPages}
          /> */}
        </div>
      </div>
    </UIWrapper>
  );
};

export default Search;
